import { forwardRef } from 'react';
import { useParams } from 'react-router-dom';
import TabNavComponent from '../../components/base/nav/TabNavComponent';

const InfosDecorator = forwardRef<
  HTMLDivElement,
  React.PropsWithChildren<object>
>(({ children }, ref) => {
  // Retrieve parameters from the URL
  const { site_id, project_id, device_id } = useParams<{
    site_id?: string;
    project_id?: string;
    device_id?: string;
  }>();

  // Dynamically define context map
  const contextMap: { [key: string]: string | undefined } = {
    project: project_id,
    site: site_id,
    device: device_id,
  };

  // Define context based on the URL param
  const context = site_id
    ? 'site'
    : project_id
    ? 'project'
    : device_id
    ? 'device'
    : 'default';

  // Define the base URL dynamically based on the context
  const baseUrl =
    context !== 'default'
      ? `/management/${context}s/${contextMap[context]}`
      : '/management/';

  // Define tabs.
  const tabs = [
    {
      name: `Infos du ${
        context === 'project'
          ? 'projet'
          : context === 'site'
          ? 'site'
          : 'dispositif de mesure'
      }`,
      url: `${baseUrl}`,
    },
    context === 'site'
      ? { name: 'stations de mesure', url: `${baseUrl}/stations` }
      : null,
    context === 'project' || context === 'site'
      ? { name: 'Infos avancées', url: `${baseUrl}/${context}_general_infos` }
      : null,
    context === 'project'
      ? { name: 'Modèles de rapport', url: `${baseUrl}/project_models` }
      : null,
  ];

  return (
    <div>
      <TabNavComponent tabs={tabs} />
      <div className="list">{children}</div>
    </div>
  );
});

export default InfosDecorator;
